import { displayBannerAd } from "@/helpers/flutter/features/ads";
import { hasSupportForAdBanners } from "@/helpers/flutter/capabilities";
import { firebaseRemoteConfig } from "@/helpers/firebase/firebase";
import { getValue } from "firebase/remote-config";
import { remoteConfigKeys } from "@/config/default-remote-config";

/**
 * Determines if banner ads should be shown based on:
 * - Remote config allows banner ads
 * - Device supports banner ads
 * - Current group has at least 5 quotes OR 3 photos
 *
 * @param currentGroup - The current group data
 * @returns true if all conditions are met, false otherwise
 */
export function shouldShowBannerAd(currentGroup: any): boolean {
  // Check if device supports banner ads
  if (!hasSupportForAdBanners()) {
    return false;
  }

  // Check if banner ads are enabled in remote config
  const bannerAdsEnabled = getValue(
    firebaseRemoteConfig,
    remoteConfigKeys.SHOW_BANNER_AD,
  )?.asBoolean();

  if (!bannerAdsEnabled) {
    return false;
  }

  // Check if there are at least 5 quotes OR 3 photos in the current group
  // There is no need to show ads if the user barely used the app
  if (
    !currentGroup?.general_data ||
    (currentGroup.general_data.number_of_quotes < 3 &&
      currentGroup.general_data.number_of_photos < 3)
  ) {
    return false;
  }

  return true;
}

/**
 * Shows the banner ad if all conditions are met
 */
export function showBannerAdIfNeeded(currentGroup: any): void {
  if (!shouldShowBannerAd(currentGroup) || !firebaseRemoteConfig) {
    return;
  }

  // Get ad unit IDs from remote config
  const adUnitIdAndroid =
    getValue(
      firebaseRemoteConfig,
      remoteConfigKeys.BANNER_AD_UNIT_ID_ANDROID,
    )?.asString() || "";

  const adUnitIdIos =
    getValue(
      firebaseRemoteConfig,
      remoteConfigKeys.BANNER_AD_UNIT_ID_IOS,
    )?.asString() || "";

  // All conditions met - show banner ad
  displayBannerAd(adUnitIdAndroid, adUnitIdIos);
}
